
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 2l11.25 6.5-3.75 3L6 8V2zm0 7l3.5 2.25L6 22 18 9v6L6 22V9z","fill":"currentColor"}}),_c('g',{attrs:{"clip-path":"url(#clip0_4677_3813)","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M23.667 17.333v2h-2M16.333 22.667v-2h2","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M17.17 19a3 3 0 014.95-1.12l1.547 1.453m-7.334 1.334l1.547 1.453A2.999 2.999 0 0022.83 21","stroke":"#253765"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4677_3813"}},[_c('path',{attrs:{"transform":"translate(16 16)","d":"M0 0h8v8H0z"}})])])])
          )
        }
      }
    